import { FC, useContext, useEffect, useState } from "react";
import { UserContext } from "features/account";
import Modal from "shared/ui/Modal";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { mailTo } from "shared/lib/email_utils";
import { ReactComponent as IconSponsorship} from "../../assets/img/icons/coins.svg";
import Input from "shared/ui/Input";
import { setIn } from "formik";
import { getOrCreateReferralCode, sendSponsorshipEmail } from "features/sponsorship";
import { User } from "shared/types/types";
import { toast } from "react-toastify";

type SponsorShipModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit?: any;
}

const iconProps = {
    fill: "#272f91",
    width: "32px",
};



const SponsorShipModal : FC<SponsorShipModalProps> = ({ isOpen, onClose }) => {
    const { user } = useContext(UserContext);
    const userType = user?.type;
    const [inputValue, setInputValue] = useState("");
    const [isValid, setIsValid] = useState(true);
    

    const handleSubmit = async (email:string) => {
        setInputValue(email);
        const response = await sendSponsorshipEmail(userType, email, referralCode) as any;
        const errorMsg = response?.response?.data?.error; 
        if (response.success){
            toast.success("Email de parrainage envoyé avec succès.");
            onClose();
        }
        else if (typeof errorMsg === "string" && errorMsg.includes(email)){
            toast.error(response.response.data.error);
        }
        else{
            toast.error("Erreur lors de l'envoi de l'email de parrainage.");
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);

        setIsValid(validateEmail(value));

      };
    

    const validateEmail = (value: string) => {
        // Simple RFC-compliant regex
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(value);
      };

    const [referralCode, setReferralCode] = useState<string | null>(null);

    const handleReferralCode = async (user: User | null) => {
        const referralCode = await getOrCreateReferralCode(userType, user);
        setReferralCode(referralCode.referralCode);
    };

    useEffect(() => {
        if (user) {
            handleReferralCode(user);
            console.log("Got referral code:", referralCode);
        }
    }, [user]);


    return (
        <>
        {isOpen && (
            <Modal
            isOpen={true}
            onClose={() => onClose()}
            title="Parrainer un Proche"
            logo={<IconSponsorship {...iconProps} />}
            infoModal={true}
            > 
            
            
            <div className="d-flex flex-column justify-content-center align-items-center mt-2">
                <span className="text-center text-dark flex-column d-flex justify-content-center align-items-center">
                    Entrer le mail de la personne à parrainer.<br/>Votre Code de Parrainage est: {referralCode || "Chargement..."}<br/>
                </span>
                <Input
                    type="email"
                    className="form-control mt-2 w-80"
                    placeholder="Email de votre filleul"
                    value={inputValue}
                    onChange={handleChange}
                    required
                />
                <Button
                    style={Button_Style.SOLID}
                    type={Button_Type.PRIMARY}
                    label="Envoyer le mail de parrainage"
                    onClick={() => isValid ? handleSubmit(inputValue): toast.error("Email invalide")}
                />
                <span className=" mt-1 text-center tag-info tag p-1">
                    Vous recevez :<b> 10 credits de plus pour vos vérifications</b>. <br />
                    Votre filleul reçoit : <b> 6 credits de vérification.</b>
                </span>
            </div>
            </Modal>
        )

        }
        </>
    )
}

export default SponsorShipModal;